<template>
  <div class="videoMonitor" :videoDialog="videoDialog">
    <el-dialog
      v-if="videoDialog"
      :class="[type == 1 ? 'video' : 'video', { minimize: minimize }]"
      ref="videoDialog"
      :modal="false"
      :title="title"
      :visible.sync="videoDialog"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      @close="closeDialog"
      width="768px"
      v-dialogDrag
    >
      <div class="search" v-if="video.playType == 4">
        <el-form :inline="true" label-width>
          <el-form-item label="回放时间">
            <el-date-picker
              v-model="historyTimeRange"
              type="datetimerange"
              unlink-panels
              range-separator="至"
              start-placeholder="回放开始时间"
              end-placeholder="回放结束时间"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="btn" v-if="video.playType == 4">
          <el-button
            type="primary"
            icon="el-icon-video-play"
            round
            @click="playElevatorVideo()"
            >播放</el-button
          >
        </div>
      </div>
      <template slot="title">
        <div class="dialog-title">
          <span>{{ $l(title) }}</span>
          <i
            class="el-icon-minus"
            @click="minimize = true"
            v-if="playerSuccess"
          ></i>
        </div>
      </template>
      <video
        id="video"
        ref="video"
        width="768"
        height="432"
        disablePictureInPicture
        disableRemotePlayback
        controls
        muted
        autoplay
        v-if="video.deviceType == 4"
      ></video>
      <div
        id="video"
        ref="video"
        v-loading.lock="loading"
        @click="clickVideoBox"
        @dblclick="fullScreen()"
        v-else
      >
        <div v-if="player && showUtil" class="video-btn">
          <svgicon
            :name="playing ? 'pause' : 'play'"
            class="play"
            @click="play()"
          ></svgicon>
          <svgicon
            :name="fullscreen ? 'cancel_fullscreen' : 'fullscreen'"
            class="fullscreen"
            @click="fullScreen()"
          >
          </svgicon>
          <svgicon
            :name="isMute ? 'sound_close' : 'sound'"
            class="sound"
            @click="sound()"
          ></svgicon>
        </div>
      </div>
    </el-dialog>
    <div class="minusbox" v-show="minimize" v-dialogDrag="true">
      <svgicon name="camera"></svgicon>
      <span>{{ $l(minTitle) }}</span>
    </div>
    <riskTipDialog
      ref="risk"
      :isSave="isSave"
      @agree="startPlayVideo()"
    ></riskTipDialog>
  </div>
</template>

<script>
import global from "@/mixins/global.js";
import EZUIKit from "ezuikit-js";
// import EzuikitFlv from "ezuikit-flv";
import "../plugins/directive.js";
import riskTipDialog from "@/components/riskTipDialog.vue";

export default {
  name: "videoMonitor",
  mixins: [global],
  components: {
    riskTipDialog,
  },
  props: {},
  data() {
    return {
      title: "视频监控",
      minTitle: "视频监控",
      loading: false,
      videoDialog: false,
      player: null,
      historyTimeRange: [],
      video: {
        jobNum: null,
        deviceSerial: "",
        deviceType: null,
        channelNo: 1,
        playType: 1, //1：视频监控，2：视频回放，3：视频对讲
        startTime: null,
        stopTime: null,
        pageInfo: "",
      },
      row: null,
      type: 2, //1代表在单梯监视页面打开视频，2：代表在电梯列表打开视频
      playing: false,
      fullscreen: false,
      isMute: true,
      showUtil: false,
      minimize: false,
      playerSuccess: false,
      isLimitPlayTime: false, //用于判断是否限制播放时间
      closePlayTimer: null, //关闭实时视频定时器
      isSave: true, //是否保存风险提示
    };
  },
  methods: {
    handleClick() {
      this.minimize = false;
    },
    playVideo(type, row){
      this.type = type;
      this.row = row;
      this.$refs.risk.show();
    },
    startPlayVideo() {
      if (this.row != undefined) {
        if (
          (this.row.pageInfo.indexOf("实时监视") != -1 ||
            this.row.pageInfo.indexOf("电梯AI运行诊断大屏") != -1) &&
          this.row.deviceType == 2
        ) {
          this.isLimitPlayTime = true;
        } else {
          this.isLimitPlayTime = false;
        }
        this.videoDialog = true;
        this.video.jobNum = this.row.jobNum;
        this.video.deviceSerial = this.row.deviceSerial;
        this.video.deviceType = this.row.deviceType;
        this.video.channelNo = this.row.channelNo ? this.row.channelNo : 1;
        this.video.playType = this.row.playType ? this.row.playType : 1;
        this.video.pageInfo = this.row.pageInfo ? this.row.pageInfo : "";
        if (this.video.playType == 1) {
          this.minimize = false;
          this.minTitle = "视频监控";
        } else if (this.video.playType == 2) {
          const { start, end } = this.$common.getTimeWithSeconds(
            new Date(this.row.alarmDate),
            15
          );
          this.video.startTime = this.$common.formatDateTime(start);
          this.video.stopTime = this.$common.formatDateTime(end);
          this.minTitle = "视频回放";
        } else if (this.video.playType == 4) {
          this.historyTimeRange[0] = new Date(
            new Date().getTime() - 300 * 1000
          );
          this.historyTimeRange[1] = new Date();
          this.minTitle = "视频回放";
        } else {
          this.minTitle = "视频对讲";
        }
        this.title = `${this.minTitle}(${this.row.jobNum})`;
      }
      if (this.video.deviceType == 4) {
        this.flvPlay();
      } else {
        this.playElevatorVideo();
      }
    },
    flvPlay() {
      if (!flvjs.isSupported()) {
        this.message(1, "浏览器不支持播放flv");
        return;
      }
      this.$nextTick(() => {
        this.loading = true;
        this.$http
          .get(this.$apiConfig.get_iot_video_url, {
            params: {
              jobNum: this.video.jobNum,
              pageInfo: this.video.pageInfo,
            },
          })
          .then((response) => {
            this.loading = false;
            let result = response.data;
            if (result.code == 0) {
              this.player = flvjs.createPlayer(
                {
                  type: "flv",
                  url: result.data.url,
                  isLive: true,
                  hasAudio: false,
                  hasVideo: true,
                  enableStashBuffer: false,
                },
                {
                  enableWorker: false,
                  enableStashBuffer: false,
                  autoCleanupSourceBuffer: true,
                }
              );
              this.player.attachMediaElement(document.getElementById("video"));
              this.player.load();
              this.player.play();
              this.player.on(flvjs.Events.ERROR, (errorType, errorDetail) => {
                this.message(1, "视频播放失败");
                console.error("视频播放失败：", errorType, errorDetail);
              });
            } else {
              this.message(1, result.msg);
            }
          })
          .catch((error) => {
            this.loading = false;
            this.message(1, "视频播放失败");
            console.log(error);
            this.$sentry.captureException(error);
          });
      });
    },
    playElevatorVideo() {
      this.destroyPlayer();
      this.loading = true;
      this.playerSuccess = false;
      if (this.video.playType == 4) {
        if (this.historyTimeRange && this.historyTimeRange.length == 2) {
          this.video.startTime = this.$common.formatDateTime(
            this.historyTimeRange[0]
          );
          this.video.stopTime = this.$common.formatDateTime(
            this.historyTimeRange[1]
          );
        } else {
          this.loading = false;
          this.message(1, "日期不能为空");
        }
      }
      this.$nextTick(() => {
        let paramData = {
          deviceSerial: this.video.deviceSerial,
          type: this.video.playType == 4 ? 2 : this.video.playType,
          quality: 2,
          protocol: this.video.playType == 3 ? 1 : 4,
          expireTime: 300,
          deviceType: this.video.deviceType,
          jobNum: this.video.jobNum,
          channelNo: this.video.channelNo,
          startTime: this.video.startTime,
          stopTime: this.video.stopTime,
          pageInfo: this.video.pageInfo,
        };
        this.$http
          .post(this.$apiConfig.get_elevator_video_path_url, paramData)
          .then((response) => {
            let result = response.data;
            if (result.code == 0) {
              const url = result.data.url;
              if (this.video.playType == 3) {
                this.player = new EZUIKit.EZUIKitPlayer({
                  id: "video",
                  accessToken: result.data.accessToken,
                  url: url,
                  template: "pcLive",
                  plugin: "talk",
                  width: 768,
                  height: 432,
                  handleSuccess() {
                    this.player.closeSound();
                  },
                });
                var footer = document.getElementById(
                  "video-ez-iframe-footer-container"
                );
                if (footer) {
                  footer.style.display = "";
                }
              } else {
                this.player = new window.EzuikitFlv({
                  url: url,
                  container: this.$refs.video,
                  decoder: "../ezuikit-flv/decoder.js",
                });
                this.player.on("error", (error) => {
                  this.loading = false;
                  console.log(error);
                  this.message(1, "视频加载失败");
                  this.destroyPlayer();
                });
                this.player.on("play", (info) => {
                  if (!this.loading) {
                    this.play();
                  }
                  this.playerSuccess = true;
                  this.loading = false;
                  document.getElementById("video").style.background = "black";
                  this.playing = this.player.getState().playing;
                  this.isMute = this.player.getState().mute;
                  if (this.isLimitPlayTime) {
                    window.clearTimeout(this.closePlayTimer);
                    this.closePlayTimer = window.setTimeout(() => {
                      this.destroyPlayer();
                    }, window.config.realPlayCloseTimerInterval);
                  }
                });
                this.player.play();
              }
            } else {
              this.loading = false;
              this.message(1, result.msg);
            }
          })
          .catch((error) => {
            this.loading = false;
            this.message(1, "视频路径获取失败");
            console.log(error);
            this.$sentry.captureException(error);
          });
      });
    },
    dialogStatus() {
      return this.videoDialog;
    },
    closeDialog() {
      this.destroyPlayer();
      this.loading = false;
      this.playerSuccess = false;
      window.clearTimeout(this.closePlayTimer);
    },
    destroyPlayer() {
      try {
        if (this.player) {
          if (this.video.deviceType == 4) {
            this.$refs.video.pause();
            this.player.pause();
            this.player.unload();
            this.player.detachMediaElement();
            this.player.destroy();
          } else {
            if (this.video.playType == 3) {
              this.player.stop();
            } else {
              this.player.destroy();
            }
          }
          this.player = null;
        }
      } catch (error) {
        this.player = null;
        console.log(error);
      }
    },
    play() {
      if (this.player) {
        if (this.player.getState().playing) {
          this.player.pause();
          this.playing = false;
        } else {
          this.player.play();
        }
      }
    },
    sound() {
      if (this.player) {
        if (this.player.getState().mute) {
          this.player.openSound();
          this.isMute = false;
        } else {
          this.player.closeSound();
          this.isMute = true;
        }
      }
    },
    fullScreen() {
      if (this.player) {
        if (this.player.getState().fullscreen) {
          this.player.cancelFullScreen();
          this.fullscreen = false;
        } else {
          this.player.fullScreen();
          this.fullscreen = true;
        }
      }
    },
    clickVideoBox(e) {
      if (e.target.tagName == "CANVAS") {
        this.showUtil = !this.showUtil;
      }
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
/deep/ #video {
  width: 100%;
  height: 432px;
}
video::-webkit-media-controls-timeline {
  display: none;
}

/deep/ #video-headControl-left {
  .theme-icon-item:nth-child(2) {
    display: none;
  }
}

/deep/ #video-deviceID-content {
  font-size: 14px;
  margin-left: 10px;
  width: 100%;
}

/deep/ #mobile-ez-ptz-container {
  display: none !important;
}

/deep/ #video-webExpend-content {
  span {
    svg {
      margin-top: 6px !important;
    }
  }
}

/deep/ #video-expend-content {
  span {
    svg:nth-child(1) {
      display: none !important;
    }
  }
}

/deep/ #video-audioControls-left {
  .theme-icon-item:nth-child(2) {
    display: none;
  }

  .theme-icon-item:nth-child(4) {
    display: none;
  }

  .theme-icon-item:nth-child(5) {
    display: none;
  }

  .theme-icon-item:nth-child(7) {
    display: none;
  }
}

/deep/ #video-audioControls-right {
  .theme-icon-item:nth-child(1) {
    display: none;
  }

  .theme-icon-item:nth-child(3) {
    display: none;
  }
}

.video {
  .search {
    margin: 0px 14px;
    height: 50px;
  }

  .el-form {
    float: left;

    // width: 450px;
    /deep/ .el-select .el-input {
      width: 160px;
    }

    /deep/ .el-date-editor .el-range-separator {
      line-height: 28px;
    }
  }

  .btn {
    float: left;
    padding-top: 2px;
    margin-left: 20px;
  }

  /deep/ .el-dialog__body {
    padding: 0px !important;
  }

  .video-btn {
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 36px;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 1;

    .play,
    .sound,
    .fullscreen {
      display: block;
      width: 24px;
      height: 24px;
      margin-top: 7px;
      cursor: pointer;
    }

    .play {
      float: left;
      margin-left: 10px;
    }

    .sound {
      float: right;
      margin-right: 10px;
    }

    .fullscreen {
      float: right;
      margin-right: 10px;
    }
  }
}

/deep/.hiddenHeader .el-dialog__header {
  display: none;
}

/deep/ .el-dialog__header {
  padding: 12px;
}

/deep/ .el-dialog__headerbtn {
  top: 14px;
}

.videoMonitor {
  /deep/.el-dialog__wrapper {
    position: static !important;
    overflow: hidden;

    .el-dialog {
      z-index: 2000;
      user-select: none;
      width: 768px;
      height: 478.5px;
      top: calc(50% - 239.25px);
      left: calc(50% - 384px);
      margin: 0 !important;
      position: fixed;
    }
  }
}

.dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 50px;

  .el-icon-minus {
    cursor: pointer;

    &:hover {
      color: #df4545;
    }
  }
}

.minimize {
  display: none;
}

.minusbox {
  width: 70px;
  height: 70px;
  background-color: #fff;
  position: fixed;
  right: 10px;
  bottom: 200px;
  border-radius: 50%;
  box-shadow: 0px 0px 6px 4px #e5e5e5;
  display: flex;
  align-items: center;
  font-size: 13px;
  justify-content: center;
  color: #df4545;
  flex-direction: column;
  user-select: none;
  z-index: 3000;
}
</style>
